import { GeneralFilterComponent } from './../../../shared/general-filter.component';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { map, startWith, take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormCd001LimpezaFilter } from 'src/app/entity/models/form-cd001-limpeza-filter';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
    selector: 'app-form-cd001-limpeza-filter',
    templateUrl: './form-cd001-limpeza-filter.component.html',
    styleUrls: ['./form-cd001-limpeza-filter.component.scss']
})

export class FormCd001LimpezaFilterComponent extends GeneralFilterComponent implements OnInit {

    public formulario?: FormGroup;
    public listSafra?: DropDownListDTO[];
    public listHibrido?: DropDownListDTO[];
    public listHibridoOriginal?: DropDownListDTO[];
    public listStatus?: DropDownListDTO[];
    public listSite?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listDeposito?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listNum?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listUsuario?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredOptionsSafra: Observable<DropDownListDTO[]>;
    public filteredOptionsHibrido: Observable<DropDownListDTO[]>;
    public filteredOptionsSite: Observable<DropDownListDTO[]>;
    public filteredOptionsDeposito: Observable<DropDownListDTO[]>;
    public filteredOptionsOrigem: Observable<DropDownListDTO[]>;
    public filteredOptionsNum: Observable<DropDownListDTO[]>;
    public filteredOptionsUsuario: Observable<DropDownListDTO[]>;

    @Output() filter = new EventEmitter();

    constructor(protected formBuilder: FormBuilder, protected formularioService: FormularioService,
        // tslint:disable-next-line: align
        protected notificationService: NotificationService, protected generalService: GeneralService) {
        super();
        this.formulario = this.formBuilder.group({
            safra: ['', []],
            site: ['', []],
            hibrido: ['', []],
            numero_controle: ['', []],
            lote_origem: ['', []],
            deposito_origem: ['', []],
            is_incomplete: ['', []],
            created_at_inicial: ['', []],
            created_at_final: ['', []],
            usuario: ['', []]
        });
    }

    async ngOnInit(): Promise<void> {
        this.listSafra = new Array<DropDownListDTO>();
        this.listHibrido = new Array<DropDownListDTO>();
        this.listHibridoOriginal = new Array<DropDownListDTO>();
        this.listOrigem = new Array<DropDownListDTO>();
        this.listSite = new Array<DropDownListDTO>();
        this.listDeposito = new Array<DropDownListDTO>();
        this.listNum = new Array<DropDownListDTO>();
        this.listUsuario = new Array<DropDownListDTO>();
        await this.getLists();
        await this.getFilters();
    }

    async sendFilter(): Promise<void> {
        this.filter.emit(await this.buildFilter());
    }

    async clearFilter(): Promise<void> {
        this.formulario.reset();
        await this.getFilters();
        this.formulario.get('site').setValue(this.generalService.getLocalStorageDataSite());
    }

    async buildFilter(): Promise<FormCd001LimpezaFilter> {
        const formulario: FormCd001LimpezaFilter = new FormCd001LimpezaFilter();
        formulario.safra = this.formulario.get('safra')?.value ?? '';
        formulario.site = this.formulario.get('site')?.value ?? '';
        formulario.hibrido = this.formulario.get('hibrido')?.value ?? '';
        formulario.numero_controle = this.formulario.get('numero_controle')?.value ?? '';
        formulario.lote_origem = this.formulario.get('lote_origem')?.value ?? '';
        formulario.deposito_origem = this.formulario.get('deposito_origem')?.value ?? '';
        formulario.is_incomplete = this.formulario.get('is_incomplete')?.value ?? '';
        formulario.created_at_inicial = !!this.formulario.get('created_at_inicial')?.value ? this.generalService.createDate(this.formulario.get('created_at_inicial')?.value) : null;
        formulario.created_at_final = !!this.formulario.get('created_at_final')?.value ? this.generalService.createDate(this.formulario.get('created_at_final')?.value) : null;
        formulario.usuario = this.formulario.get('usuario')?.value ?? ''
        return formulario;
    }

    async getLists(): Promise<void> {
        await Promise.all([
            this.getListSafra(),
            this.getListHibrido(),
            this.getListStatus(),
            this.getListSite(),
            this.getListDestino(),
            this.getListNum(),
            this.getListOrigem(),
            this.getListUsuario(),
            this.getListHibridoRNC(),
        ]);
    }

    async getListSafra(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'safra').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSafra = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSafra);
        });
    }

    async getListHibrido(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'hibrido_rnc').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listHibrido = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
        });
    }

    async getListHibridoRNC(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'hibrido_rnc')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listHibrido = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listHibridoOriginal = this.listHibrido;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorHibrido
                );
            });
    }

    async getListSite(): Promise<void> {
        this.listSite = this.generalService.getListSiteRecebimento();
        // await this.formularioService.getListDropDownList('qua007', 'site_origem').pipe(take(1)).toPromise().then(response => {
        //     if (!!response?.data) {
        //         this.listSite = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        //     }
        // }).catch(async (error: HttpErrorResponse) => {
        //     this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
        // });
    }

    async getListOrigem(): Promise<void> {
        await this.formularioService.getListDropDownList('cd001_prelimpeza', 'lote_origem').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listOrigem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorLoteOrigem);
        });
    }

    async getListDestino(): Promise<void> {
        await this.formularioService.getListDropDownList('cd001_prelimpeza', 'deposito_origem').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listDeposito = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorDepositoOrigem);
        });
    }

    async getListNum(): Promise<void> {
        await this.formularioService.getListDropDownList('cd001_prelimpeza', 'numero_controle').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listNum = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorNumControl);
        });
    }

    async getListUsuario(): Promise<void> {
        await this.formularioService.getList('cd001_prelimpeza', 'usuario',this.generalService.getLocalStorageDataSite()).pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listUsuario = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, 'Erro para montar a lista de usuários', TypeMessage.Personalized);
        });
    }

    async getListStatus(): Promise<void> {
        this.listStatus = await this.generalService.getListStatus();
    }

    async getFilters(): Promise<void> {
        await Promise.all([
            this.createFilterSafra(),
            this.createFilterHibrido(),
            this.createFilterNum(),
            this.createFilterSite(),
            this.createFilterOrigem(),
            this.createFilterDeposito(),
            this.createFilterUsuario()
        ]);
    }

    async createFilterSafra(): Promise<void> {
        this.filteredOptionsSafra = this.formulario.get('safra').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listSafra, value))
            );
    }

    createFilterHibrido(value?: string): void {
        this.listHibrido = this.generalService.applyFilter(value, this.listHibridoOriginal, this.listHibrido);
    }

    // async createFilterHibrido(): Promise<void> {
    //     this.filteredOptionsHibrido = this.formulario.get('hibrido').valueChanges
    //         .pipe(
    //             startWith(''),
    //             map(value => this.generalService._filterDropDownList(this.listHibrido, value))
    //         );
    // }

    async createFilterOrigem(): Promise<void> {
        this.filteredOptionsOrigem = this.formulario.get('lote_origem').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listOrigem, value))
            );
    }

    async createFilterSite(): Promise<void> {
        this.filteredOptionsSite = this.formulario.get('site').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listSite, value))
            );
    }

    async createFilterDeposito(): Promise<void> {
        this.filteredOptionsDeposito = this.formulario.get('deposito_origem').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listOrigem, value))
            );
    }

    async createFilterNum(): Promise<void> {
        this.filteredOptionsNum = this.formulario.get('numero_controle').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listOrigem, value))
            );
    }

    async createFilterUsuario(): Promise<void> {
        this.filteredOptionsUsuario = this.formulario.get('usuario').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listUsuario, value))
            );
    }
}
